import { useTranslation } from 'react-i18next';

export const useI18n = (namespace?: string | string[]) => {
  const defaultNamespace = namespace || 'home';
  const { t, i18n } = useTranslation(defaultNamespace);

  const changeLanguage = (lang: string) => {
    return i18n.changeLanguage(lang);
  };

  const currentLanguage = i18n.language;

  const languages = {
    en: 'English',
    es: 'Español',
    zh: '中文',
    ca: 'Català',
    ma: 'العربية (المغرب)',
    pt: 'Português',
    fr: 'Français',
    ro: 'Română',
  };

  return {
    t,
    changeLanguage,
    currentLanguage,
    languages,
    i18n,
  };
};

// Specialized hooks for different features
export const useHomeTranslations = () => useI18n('home');
export const usePwaTranslations = () => useI18n('pwa');

// Legal page translation hooks
export const useDisclaimerTranslations = () => useI18n('disclaimer');
export const usePrivacyPolicyTranslations = () => useI18n('privacy-policy');
export const useTermsOfServiceTranslations = () => useI18n('terms-of-service');
export const useCookiePolicyTranslations = () => useI18n('cookie-policy');

// Auth translation hook
export const useAuthTranslations = () => useI18n('auth');

// Dashboard translation hook
export const useDashboardTranslations = () => useI18n('dashboard');

// Vehicles translation hook
export const useVehiclesTranslations = () => useI18n('vehicles');

// Quick Links translation hook
export const useQuickLinksTranslations = () => useI18n('quick-links');

// About translation hook
export const useAboutTranslations = () => useI18n('about');
